import { classnames } from '@library/utils';
import React from 'react';
import { ButtonlikeSize, ButtonlikeVariant, ButtonlikeWidth } from '../types';
import { useButtonClasses } from '../use-button-classes';
import { BaseButton, BaseButtonProps } from './base';

interface PrimaryButtonProps
  extends Omit<BaseButtonProps, 'className' | 'size' | 'usage' | 'variant'> {
  variant?: ButtonlikeVariant;
  size?: ButtonlikeSize;
  width?: ButtonlikeWidth;
}

const PrimaryButton = React.forwardRef<HTMLButtonElement, PrimaryButtonProps>(
  function PrimaryButtonWithRef(
    {
      size = 'size.md',
      variant = 'variant.base',
      width = 'width.unset',
      ...delegated
    },
    ref
  ) {
    return (
      <BaseButton
        {...delegated}
        className={classnames(
          useButtonClasses({ size, usage: 'usage.primary', variant, width })
        )}
        ref={ref}
      />
    );
  }
);

export type { PrimaryButtonProps };
export { PrimaryButton };
